const FiltersIcon = ({ onClick }) => {
    return (
        <button className="px-3 py-2 text-white rounded-lg hover:bg-gray-300" onClick={onClick}>
            Reset filters
        </button>
    )
}

const CloseIcon = ({ onClick }) => {
    return (
        <button onClick={onClick} className="text-white mr-4">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
        </button>
    )
}


const CheckedIcon = ({ isClickedBtn }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={`${!isClickedBtn ? 'hidden' : 'block '}${' w-6 h-6 '}`}>
            <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clipRule="evenodd" />
        </svg>
    )
}

export {
    FiltersIcon,
    CloseIcon,
    CheckedIcon
}